// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"index_page_wrapper__rczS9","marginBottom":"index_page_marginBottom__3E-H-","content":"index_page_content__23qc1"};